import "../controllers/index";
import "@hotwired/turbo-rails";
import {
  onPreviewIframeFormSubmission,
  onLinkClick,
} from "../controllers/site_builder/customization/event";
import Customization from "../controllers/site_builder/customization";
import { navigateWithConfirm } from "../controllers/site_builder/customization/lib";

document.addEventListener("turbo:load", function () {
  /*
    Search for all the links inside the site builder preview body except js links or tel links
    Make a turbo request to load the requested page without reloading the page.
  */
  onLinkClick(async (e, target) => {
    e.preventDefault();
    const { domain } = document.body.dataset;
    const href = target.getAttribute("href");
    if (!href) return;

    const internalLinkPattern = new RegExp('https?://' + domain);
    const match = href.match(internalLinkPattern) || href.startsWith('/');

    if (match) {
      document.body.style.overflow = "auto";
      document.body.classList.remove("mobile-menu-active");

      let path;

      try {
        const url = new URL(href);
        path = url.pathname;
      } catch (error) {
        // If there's an error, assign path as href
        path = href;
      }

      /*
          Disabling comments and replies on site builder
       */
      if (path.includes("comment")) return;

      const targetValue = target.getAttribute("target");
      if (targetValue) {
        window.open(href, targetValue);
      } else {
        await Customization.pageLoad(path);
      }
    } else {
      const isPersisted = !!document.body.dataset.siteBuilderSite
      if (isPersisted) {
        const targetValue = target.getAttribute("target");
        if (targetValue) {
          window.open(href, targetValue);
        } else {
          navigateWithConfirm(href)
        }
      } else {
        window.open(href);
      }
    }
  })

  onPreviewIframeFormSubmission((submission) => {
    submission.stop();
  });
});
